import get from 'lodash/get';

const NAMESPACE = 'partners';

export const selectPartners = (state) => get(state, NAMESPACE, {});
